import React from 'react';
// import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';

const Test: React.FC<{ noBottomLogo?: boolean; }> = () => (
  // const hubConnection = new HubConnectionBuilder()
  //   .withUrl('http://localhost:5000/notify')
  //   .configureLogging(LogLevel.Trace)
  //   .build();

  // hubConnection.on('sendNewNotification', (user, type, message, totalAdd) => {
  // });

  // hubConnection
  //   .start()
  //   .then((a) => {
  //     // Once started, invokes the sendConnectionId in our ChatHub inside our ASP.NET Core application.
  //   })
  //   .catch((err) => console.log('Error while establishing connection :('));

  <div>Testando SignalR, abra o console e verifique se esta logando msgs</div>
);
export default Test;
